export const paths = {
  home: "/",
  experience: "/experience",
  education: "/education",
  projects: "/projects",
} as const;
